module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_1.ce839ab0.mp3";